export default __webpack_public_path__ + "static/media/badge-border-purple.b52b50b3.png";